import { ITrackingMapper } from '@bridebook/web/lib/track-utils/tracking-mappers';
import { mapEventToAppsFlyerEvent } from './event-to-appsflyer-event';

export const signedUpMapper: ITrackingMapper<{
  registrationMethod: string;
  userId: string;
  currency?: string;
}> = ({ event, payload }) => [
  mapEventToAppsFlyerEvent(event),
  {
    af_registration_method: payload.registrationMethod,
    af_customer_user_id: payload.userId,
    af_currency: payload.currency,
  },
];
